  export class TemplateParameters {
    /**
     * Defines the prompt parameters defined in CordialLLM
     * 
     * @param template_id The id of the template (ex: rephrase-vigogne-2-13b-chat)
     * @param value The associated parameters. (ex: ["style", "examples"])
     */
    constructor(public template_id: string,
                public value: string[]) {}
  }
  